import { Document, File } from ".";

export class Folder {
    private readonly _name: string;

    public get name(): string {
        return this._name;
    }

    private readonly _folders: Folder[];

    public get folders(): Folder[] {
        return this._folders;
    }

    private readonly _files: File[];

    public get files(): File[] {
        return this._files;
    }

    constructor(name: string) {
        this._name = name;
        this._folders = [];
        this._files = [];
    }

    public add(object: Document, recur: number): void {
        let newRecur = recur;

        if (recur > 100) {
            return;
        } else {
            newRecur++;
        }

        if (object.folders.length > 0) {
            const newFolder: string = object.folders.shift();

            let folder: Folder = this.folders.find((f) => f.name === newFolder);

            if (folder) {
                folder.add(object, newRecur);
            } else {
                this._folders.push(new Folder(newFolder));
                folder = this.folders.find((f) => f.name === newFolder);
                folder.add(object, newRecur);
            }
        } else {
            this._files.push(new File(object.id, object.fileName));
        }
    }

    public getAllFiles(): File[] {
        let allFiles: File[] = [];

        for (let i = 0; i < this._files.length; i++) {
            allFiles.push(this._files[i]);
        }

        if (this._folders.length == 0) {
            return allFiles;
        }

        for (let i = 0; i < this._folders.length; i++) {
            allFiles = allFiles.concat(this._folders[i].getAllFiles());
        }
        return allFiles;
    }
}
